<template>
  <sweet-modal
    overlay-theme="dark"
    hide-close-button
    ref="modal"
    enable-mobile-fullscreen
    class="no-padding-content"
    :width="$mq == 'mobile' ? '100%' : '50%'"
    @close="modalClosed"
  >
    <div class="bg-modal-gradient flex justify-between items-center p-6">
      <div class="text-white text-3xl">
        <i class="fa fa-key mr-4"></i> Add key document
      </div>
      <div>
        <button
          type="button"
          class="text-white text-2xl hover:text-grey"
          @click="$refs.modal.close()"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>
    <form
      @submit.prevent="saveKeyDocument"
      data-vv-scope="new-key-document"
      ref="drop_target"
      class="p-6"
      enctype="multipart/form-data"
    >
      <div class="w-full text-left my-4">
        <div class="flex justify-between">
          <label class="font-medium"
            >Title <span class="text-red">*</span></label
          >
          <label class="text-red text-sm font-medium">* Required info</label>
        </div>
        <input
          type="text"
          class="w-full h-10 border rounded px-3 mt-1"
          v-model="keyDocument.title"
          v-validate="'required'"
          name="title"
          tabindex="1"
          :class="{ 'border-red': errors.has('new-key-document.title') }"
        />
        <div
          v-show="errors.has('new-key-document.title')"
          class="text-red text-sm mt-1"
        >
          {{ errors.first("new-key-document.title") }}
        </div>
      </div>
      <div class="w-full text-left my-4">
        <label class="font-medium">Description</label>
        <textarea
          class="w-full border rounded py-2 px-3 mt-1"
          v-model="keyDocument.description"
          name="description"
          tabindex="1"
          :class="{ 'border-red': errors.has('new-key-document.description') }"
        ></textarea>
        <div
          v-show="errors.has('new-key-document.description')"
          class="text-red text-sm mt-1"
        >
          {{ errors.first("new-key-document.description") }}
        </div>
      </div>

      <file-upload
        ref="fileUpload"
        v-show="!vault.storage_exceeded"
      ></file-upload>

      <div
        v-if="vault.storage_exceeded"
        class="
          mt-4
          bg-red-lightest
          border border-dashed
          w-full
          p-1
          border-red
          text-sm
        "
      >
        Vault Storage Exceeded, uploading is not allowed
      </div>

      <div class="mt-6 flex justify-between items-center">
        <button
          class="bg-brand border border-brand text-white text-sm font-medium py-2 px-4 rounded hover:bg-brand-dark hover:border-brand-dark"
          type="submit"
        >
          <i class="fa fa-plus mr-2"></i> Add
        </button>
      </div>
    </form>
  </sweet-modal>
</template>

<script>
import axios from "axios";
import FileUpload from "../FileUpload.vue";

export default {
  name: "AddKeyDocument",

  props: ["vault"],

  components: {
    FileUpload,
  },

  data() {
    return {
      keyDocument: {
        title: "",
        description: "",
      },
    };
  },

  methods: {
    resetState() {
      this.keyDocument = {
        title: "",
        description: "",
      };

      this.errors.clear("new-key-document");

      // fix errors not clearing completely
      this.$nextTick(() => {
        this.errors.clear();
        this.$nextTick(() => {
          this.$validator.reset();
        });
      });
    },

    saveKeyDocument() {
      this.$validator.validateAll("new-key-document").then((result) => {
        if (result) {
          this.$emit("processing", true);

          // build form data
          const formData = new FormData();
          formData.append("title", this.keyDocument.title);
          formData.append("description", this.keyDocument.description);

          const files = this.$refs.fileUpload.getFiles();
          const vaultFiles = this.$refs.fileUpload.getVaultFiles();
          files.forEach((file, index) => {
            formData.append(`files[${index}]`, file);
          });
          vaultFiles.forEach((file, index) => {
            formData.append(`vault_files[${index}]`, file.id);
          });

          // send API request
          axios
            .post(
              `api/vaults/${this.$route.params.vault_id}/key-documents`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((response) => {
              if (response && response.data) {
                const data = response.data;
                if (data.success) {
                  this.$noty.success(data.message);
                }
              }
              this.resetState();
              this.$emit("getKeyDocuments");
              this.$emit("processing", false);
              this.$refs.modal.close();
            })
            .catch((response) => {
              if (response && response.data && !response.data.success) {
                this.$emit("processing", false);
                this.$noty.error(response.data.message);
              }
            });
        }
      });
    },

    modalClosed() {
      this.resetState();
      this.$refs.fileUpload.cleanup();
    },
  },
};
</script>